<template>
  <div class="registeredCamsTable">
    <setting-header />
    <v-spacer class="registeredCamsTable_gap-header" />
    <image-display-select @onSelect="handleSelectDisplayImage" />
    <div class="registeredCamsTable_videos">
      <v-data-table
        v-model="selectedClips"
        :headers="computedHeaders"
        :items="tableItems"
        hide-default-footer
        disable-pagination
        item-key="index"
        sort-by="dateTime"
        :fixed-header="true"
        class=""
      >
        <!-- Table body template  -->
        <template v-slot:item="{ item, isSelected, select }">
          <tr
            :class="isSelected ? 'selected' : ''"
            @click="toggleSelect(item, isSelected, select, $event)"
          >
            <td v-if="displayImage" class="text-start">
              <v-img
                v-if="item.thumbnailUrl"
                :src="item.thumbnailUrl"
                class="registeredCamsTable_tbl-img"
                height="66px"
                width="117px"
              >
                <div v-if="isSelected" class="registeredCamsTable_select-icon">
                  <span class="icon icon-check" />
                </div>
              </v-img>
              <no-image v-else width="117px" height="66px">
                <div v-if="isSelected" class="registeredCamsTable_select-icon">
                  <span class="icon icon-check" />
                </div>
              </no-image>
            </td>
            <td class="text-start">
              {{ item.camName }}
            </td>
            <td class="text-start">
              <span class="registeredCamsTable_tbl-dateTime">
                {{ item.camPropName }}
              </span>
            </td>
            <td class="text-center">
              <span class="registeredCamsTable_tbl-modelName">
                {{ item.modelName }}
              </span>
            </td>
            <td class="text-center">
              <span
                v-if="!!item.serialNumber"
                class="registeredCamsTable_tbl-serialNumber"
              >
                {{ item.serialNumber }}
              </span>
            </td>
            <td class="text-center">
              <span class="registeredCamsTable_tbl-firmwareVerion">
                {{ item.firmwareVersion }}
              </span>
            </td>
            <td class="text-center">
              <span class="registeredCamsTable_tbl-packageVersion">
                {{ item.packageVersion }}
              </span>
            </td>
          </tr>
        </template>
        <!-- ----------------- -->
        <!-- Table no data -->
        <template v-slot:no-data>
          <h3>No Data</h3>
        </template>
        <!-- ----------------- -->
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ImageDisplaySelect from './ImageDisplaySelect.vue';
import { MimeTypes } from '@/globals/enums';
import SettingHeader from './SettingHeader.vue';
export default {
  name: 'RegisteredCamsTable',
  components: {
    ImageDisplaySelect,
    SettingHeader,
  },
  data: () => ({
    mimeTypes: MimeTypes,

    headers: [
      {
        value: 'thumbnailUrl',
        align: 'start',
        sortable: false,
      },
      {
        text: '名前',
        align: 'start',
        sortable: false,
        value: 'name',
      },
      {
        text: 'カメラ物件名称',
        value: 'camPropName',
        align: 'start',
        sortable: false,
      },
      { text: '機種名', value: 'modelName', align: 'center', sortable: false },
      {
        text: 'シリアル番号',
        value: 'serialNumber',
        sortable: false,
        align: 'center',
      },
      {
        text: 'ファームウエアバージョン',
        value: 'cameraName',
        sortable: false,
        align: 'center',
      },
      {
        text: 'パッケージバージョン',
        value: 'createDate',
        align: 'center',
        sortable: false,
      },
    ],
    selectedClips: [],
    clipToolsOpen: false,
    displayImage: false,
  }),

  computed: {
    ...mapState({
      videoClips: (state) =>
        state.video.videoClips.map((item, index) => ({ ...item, index })),
      cameraList: (state) => state.common.cameraList,
      searchKeys: (state) => state.common.searchKeys,
      cameraById: (state) => state.common.cameraById,
      tableItems: (state) => state.settings.registeredCams,
    }),
    computedHeaders() {
      return this.headers.map((item) => ({
        ...item,
        align:
          item.value === 'thumbnailUrl'
            ? this.displayImage
              ? 'start'
              : ' d-none'
            : item.align,
      }));
    },
  },

  created() {
    // this.initialize();
  },
  mounted() {},
  methods: {
    handleSelectDisplayImage(index) {
      this.displayImage = !!index;
    },
    toggleSelect(item) {
      this.$router.push({
        name: 'settings',
        params: { parent: 'info', child: item.id },
      });
    },
  },
};
</script>

<style lang="scss">
.registeredCamsTable {
  &_gap-header {
    height: 5px;
  }
  &_select {
    &-icon {
      width: 34px;
      height: 34px;
      padding: 5px 5px 5px 5px;
      background-color: #0075c2;
      border-radius: 50%;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate3d(-50%, -50%, 0);
      .icon-check {
        color: #fff;
        font-size: 25px;
        font-weight: 900;
      }
    }
  }
  &_tbl {
    &-img {
      margin: 10px;
    }
    &-dateTime {
      font-size: 14px;
      font-weight: 600;
      color: #666;
      text-align: center;
    }
    &-packageVersion {
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
    }
    &-modelName {
      font-size: 14px;
      font-weight: 600;
      color: #666;
    }
    &-serialNumber {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: left;
      color: #666;
      font-family: 'Noto Sans JP', sans-serif;
    }
    &-firmwareVerion {
      font-size: 14px;
      font-weight: 600;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.43;
      letter-spacing: normal;
      text-align: center;
      color: #666;
      font-family: 'Noto Sans JP', sans-serif;
    }
  }
  th {
    vertical-align: bottom;
    min-width: 130px;
    span {
      font-family: 'Noto Sans JP', sans-serif;
      font-size: 12px;
      font-weight: bold;
      color: #4b4b4b;
    }
  }
  td {
    vertical-align: middle;
    max-width: 75px;
    .noThumbnailImage {
      margin: 10px;
    }
  }
  tr.selected {
    background-color: #f3f3f3 !important;
    border-color: #f3f3f3 !important;
  }
  &_btn {
    margin-right: 5px;
  }
  display: flex;
  flex-direction: column;
  &_subtitle {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;
    color: #989898;
  }
  &_title {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 2px;
    color: var(--text-color);
    max-width: 966px;
    @media (min-width: 1280px) {
      width: calc(68vw - 339.77px);
    }
    &_text {
      font-size: 20px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: left;
      color: #4b4b4b;
    }
    &_type {
      color: var(--warning-color-lighten1);
      font-size: 12px;
      font-weight: 600;
    }
  }
  &_videos {
    position: relative;
  }
  .v-btn {
    &:not(.v-btn--round).v-size--x-small {
      padding-left: 8px;
      padding-right: 8px;
      &.v-btn--outlined {
        padding-left: 7px;
        padding-right: 7px;
        color: #989898;
        border-color: #989898;
      }
    }
    &:not(:last-child) {
      margin-right: 8px;
    }
  }
}
</style>
